// extracted by mini-css-extract-plugin
module.exports = {"filterModal":"FilterModal_filterModal__yB8Jf","container":"FilterModal_container__7NRUR","cancelIcon":"FilterModal_cancelIcon__7VNXQ"};